export enum Plans {
  free = 'free',
  basic = 'basic',
  pro = 'pro',
  premium = 'premium',
  enterprise = 'enterprise',
}

export enum PlanBillingCycle {
  MONTHLY = 'monthly',
  YEARLY = 'yearly',
}
